export default "__VITE_ASSET__7vRN6kgi__"